{
  "author": "kevinchatham",
  "bin": {
    "tressi": "dist/cli.js"
  },
  "dependencies": {
    "@acrodata/code-editor": "^0.6.0",
    "@codemirror/language-data": "^6.5.2",
    "@hono/node-server": "^1.19.6",
    "@hono/standard-validator": "^0.2.0",
    "@tailwindcss/postcss": "^4.1.17",
    "better-sqlite3": "^12.6.0",
    "chalk": "^5.4.1",
    "cli-table3": "^0.6.5",
    "clipboard": "^2.0.11",
    "commander": "^14.0.0",
    "dayjs": "^1.11.19",
    "emoji-toolkit": "^10.0.0",
    "eventemitter3": "^5.0.1",
    "fuse.js": "^7.1.0",
    "hdr-histogram-js": "^3.0.1",
    "hono": "^4.10.6",
    "kysely": "^0.28.9",
    "marked": "^17.0.2",
    "mermaid": "^11.12.2",
    "ng-apexcharts": "^2.0.3",
    "ngx-markdown": "^21.1.0",
    "ora": "^8.2.0",
    "postcss": "^8.5.6",
    "prismjs": "^1.30.0",
    "rxjs": "~7.8.0",
    "semver": "^7.7.4",
    "tailwindcss": "^4.1.17",
    "tslib": "^2.3.0",
    "undici": "^7.3.0",
    "unique-names-generator": "^4.7.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zod": "4.0.1"
  },
  "description": "Deterministic load testing for API performance validation.",
  "devDependencies": {
    "@biomejs/biome": "2.4.7",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.0.0",
    "@types/prismjs": "^1.26.6",
    "@types/semver": "^7.7.1",
    "@vitest/browser-playwright": "^4.0.18",
    "@vitest/coverage-v8": "^4.0.18",
    "@vitest/ui": "^4.0.15",
    "chokidar-cli": "^3.0.0",
    "daisyui": "^5.5.5",
    "jasmine-core": "~5.9.0",
    "jsdom": "^28.1.0",
    "nodemon": "^3.1.11",
    "postcss": "^8.5.3",
    "prettier": "^3.6.2",
    "prettier-plugin-tailwindcss": "^0.7.1",
    "rimraf": "^6.1.0",
    "ts-morph": "^25.0.1",
    "tsup": "^8.5.0",
    "tsx": "^4.20.3",
    "typescript": "~5.9.2",
    "vitest": "^4.0.18"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "files": [
    "dist",
    "LICENSE",
    "package.json",
    "README.md"
  ],
  "keywords": [
    "load testing",
    "stress testing",
    "performance",
    "benchmark",
    "api testing",
    "http",
    "dashboard",
    "gui",
    "cli",
    "multithreaded",
    "realtime",
    "automation",
    "autocannon",
    "artillery",
    "wrk"
  ],
  "license": "SEE LICENSE IN LICENSE",
  "main": "dist/index.js",
  "name": "tressi",
  "repository": {
    "directory": "",
    "type": "git",
    "url": "git+https://github.com/kevinchatham/tressi.git"
  },
  "scripts": {
    "build": "npx rimraf dist && npx rimraf server/dist && npm run cli:build && npm run ui:build && cp -r projects/cli/dist dist",
    "check": "biome check --config-path biome.standalone.json --write . && prettier --write . --config .prettierrc --ignore-path .prettierignore",
    "check:watch": "chokidar \"**/*.{ts,html,css,yml,yaml,json,md}\" -c \"npm run check\" --ignore \"**/{node_modules,dist}/**\"",
    "clean": "npx rimraf --glob \"**/package-lock.json\" \"**/dist\" \"**/node_modules\" \"**/.angular\"",
    "cli:build": "npm run build -w projects/cli",
    "cli:run": "npm run run -w projects/cli",
    "cli:serve": "nodemon",
    "docker": "tsx scripts/docker.ts",
    "kill": "fuser -k 3108/tcp && fuser -k 4200/tcp && fuser -k 5000/tcp && fuser -k 8000/tcp && fuser -k 8001/tcp",
    "start:test:server": "npx tsx projects/e2e/setup/test-server.ts",
    "test": "npm run test:cli && npm run test:ui && npm run test:e2e",
    "test:cli": "npm run test -w projects/cli",
    "test:e2e": "npm run test -w projects/e2e",
    "test:install": "npx playwright install --with-deps chromium",
    "test:ui": "npm run test -w projects/ui",
    "typecheck": "npm run typecheck -w projects/cli && npm run typecheck -w projects/shared",
    "ui:build": "npm run build -w projects/ui",
    "ui:build:dev": "npm run build:dev -w projects/ui",
    "ui:serve": "npm run serve -w projects/ui"
  },
  "type": "commonjs",
  "version": "0.0.20",
  "workspaces": [
    "projects/cli",
    "projects/ui",
    "projects/shared",
    "projects/e2e"
  ]
}
